// removed by extract-text-webpack-plugin
module.exports = {"List":"_JOAtv","ListItem":"_1R5zU","ListItemDisabled":"_2jEcW","ListImage":"_28Xl4","ListHeadingBox":"_2W1hw","ListHeadingBoxInner":"_XkpR3","ListButtonBox":"_29cws","Image":"_JnOYG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Extras/Extras.scss
// module id = 565
// module chunks = 0